import { css, keyframes, useTheme } from '@emotion/react';
import { CheckCircle, Circle, CircleNotch, Warning, XCircle } from '@phosphor-icons/react';
import { StatusItemState } from 'common/status/StatusDocument';

export interface StatusTreeTagIconProps {
  icon?: JSX.Element;
  itemStateID: StatusItemState;
  isReady?: boolean;
}

export const StatusTreeTagIcon = ({ icon, itemStateID, isReady = true }: StatusTreeTagIconProps) => {
  const theme = useTheme();

  const statusItemStateToIcon = {
    [StatusItemState.GREEN]: icon || <CheckCircle weight="fill" color={theme.color.green[100]} />,
    [StatusItemState.YELLOW]: <Warning weight="fill" color={theme.color.yellow[100]} />,
    [StatusItemState.RED]: <XCircle weight="fill" color={theme.color.red[100]} />,
    [StatusItemState.GRAY]: icon || <Circle weight="bold" />,
  };

  if (!isReady) return <CircleNotch weight="bold" css={loadingStyle} />;

  return statusItemStateToIcon[itemStateID];
};

const spinAnimation = keyframes`
  0% { transform: translateY(-1px) rotate(0deg); }
  100% { transform: translateY(-1px) rotate(360deg); }
`;

const loadingStyle = css`
  animation: ${spinAnimation} 1s infinite linear;
`;
